<template>
  <PageTitle title="Email Notifications" />
  <FlyBox> </FlyBox>
</template>

<script>
import FlyBox from 'shared/components/Grid/FlyBox';
import PageTitle from 'shared/components/Page/PageTitle';

export default {
  name: 'NotificationView',
  components: {
    FlyBox,
    PageTitle,
  },
};
</script>

<style lang="scss"></style>
